export default __webpack_public_path__ + "static/media/mouseLeftClick.0b7b127f.svg";